var _path, _circle, _circle2, _circle3, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAice = function SvgAice(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 80,
    id: "Outline",
    viewBox: "0 0 64 64",
    width: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54,11H20c-1.6543,0-3,1.3457-3,3v23h-7.375c-1.44727,0-2.625,1.14648-2.625,2.55566v10.88867c0,1.40918,1.17773,2.55566,2.625,2.55566h20.75c1.44727,0,2.625-1.14648,2.625-2.55566v-3.44434h21c1.6543,0,3-1.3457,3-3V14c0-1.6543-1.3457-3-3-3ZM20,13h34c.55176,0,1,.44824,1,1v5H19v-5c0-.55176.44824-1,1-1ZM31,50.44434c0,.30664-.28027.55566-.625.55566H9.625c-.34473,0-.625-.24902-.625-.55566v-10.88867c0-.30664.28027-.55566.625-.55566h20.75c.34473,0,.625.24902.625.55566v10.88867ZM54,45h-21v-5.44434c0-1.40918-1.17773-2.55566-2.625-2.55566h-11.375v-16h36v23c0,.55176-.44824,1-1,1Z",
    fill: "currentColor",
    strokeWidth: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 16,
    fill: "currentColor",
    r: 1,
    strokeWidth: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 16,
    fill: "currentColor",
    r: 1,
    strokeWidth: 0
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 16,
    fill: "currentColor",
    r: 1,
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.70703,41.29297c-.39062-.39062-1.02344-.39062-1.41406,0s-.39062,1.02344,0,1.41406l2.29297,2.29297-2.29297,2.29297c-.39058.39058-.39062,1.02329-.00013,1.41393.36423.36436,1.02062.39369,1.41419.00013l3-3c.39062-.39062.39062-1.02344,0-1.41406l-3-3Z",
    fill: "#05F283",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.70703,41.29297c-.39062-.39062-1.02344-.39062-1.41406,0l-3,3c-.39062.39062-.39062,1.02344,0,1.41406l2.99999,2.99999c.36617.36617,1.01983.39424,1.41407,0,.39062-.39062.39062-1.02344,0-1.41406l-2.29297-2.29297,2.29297-2.29297c.39062-.39062.39062-1.02344,0-1.41406Z",
    fill: "#05F283",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.31641,41.05176c-.52734-.17676-1.09082.1084-1.26465.63184l-2,6c-.1748.52441.1084,1.09082.63246,1.26486.51959.17282,1.0903-.11089,1.26402-.63204l2-6c.1748-.52441-.1084-1.09082-.63184-1.26465Z",
    fill: "#05F283",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42,28c-1.6543,0-3,1.3457-3,3v6c0,.55273.44727,1,1,1s1-.44727,1-1v-2h2v2c0,.55273.44727,1,1,1s1-.44727,1-1v-6c0-1.6543-1.3457-3-3-3ZM41,33v-2c0-.55176.44824-1,1-1s1,.44824,1,1v2h-2Z",
    fill: "#05F283",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48,28c-.55273,0-1,.44727-1,1v8c0,.55273.44727,1,1,1s1-.44727,1-1v-8c0-.55273-.44727-1-1-1Z",
    fill: "#05F283",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50,24h-12c-1.6543,0-3,1.3457-3,3v12c0,1.6543,1.3457,3,3,3h12c1.6543,0,3-1.3457,3-3v-12c0-1.6543-1.3457-3-3-3ZM51,39c0,.55176-.44824,1-1,1h-12c-.55176,0-1-.44824-1-1v-12c0-.55176.44824-1,1-1h12c.55176,0,1,.44824,1,1v12Z",
    fill: "currentColor",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22,26h6c.55273,0,1-.44727,1-1s-.44727-1-1-1h-6c-.55273,0-1,.44727-1,1s.44727,1,1,1Z",
    fill: "currentColor",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32,28h-10c-.55273,0-1,.44727-1,1s.44727,1,1,1h10c.55273,0,1-.44727,1-1s-.44727-1-1-1Z",
    fill: "currentColor",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32,32h-10c-.55273,0-1,.44727-1,1s.44727,1,1,1h10c.55273,0,1-.44727,1-1s-.44727-1-1-1Z",
    fill: "currentColor",
    strokeWidth: 0
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAice);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "aice.008e23a68f5716c21260a709faecdef1.svg";